import { Toaster } from 'react-hot-toast';
import { useToken } from '@chakra-ui/react';

const ToasterProvider = () => {
  const [
    successBg,
    successText,
    successBorder,
    successIcon,
    errorBg,
    errorText,
    errorBorder,
    errorIcon,
  ] = useToken('colors', [
    'brand.toast.success.bg',
    'brand.toast.success.text',
    'brand.toast.success.border',
    'brand.toast.success.icon',
    'brand.toast.error.bg',
    'brand.toast.error.text',
    'brand.toast.error.border',
    'brand.toast.error.icon',
  ]);

  return (
    <Toaster toastOptions={{
      duration: 3000,
      success: {
        style: {
          borderRadius: '10px',
          background: successBg,
          color: successText,
          border: `1px solid ${successBorder}`,
          padding: '16px',
          fontSize: '14px',
          fontWeight: '500',
        },
        iconTheme: {
          primary: successIcon,
          secondary: successBg,
        },
      },
      error: {
        style: {
          borderRadius: '10px',
          background: errorBg,
          color: errorText,
          border: `1px solid ${errorBorder}`,
          padding: '16px',
          fontSize: '14px',
          fontWeight: '500',
        },
        iconTheme: {
          primary: errorIcon,
          secondary: errorBg,
        },
      },
    }} />
  )
}

export default ToasterProvider